import { push } from 'connected-react-router'
import isMobile from 'ismobilejs'
import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import {
  catchError,
  filter,
  map,
  mergeMap,
  pluck,
  startWith,
} from 'rxjs/operators'

import config from 'config'
import { DealStatus } from 'constants/dealConstants'
import { Flow } from 'constants/flowConstants'
import * as UserSelectors from 'modules/user/selectors'
import { track } from 'utils/trackingUtils'

import * as actions from './actions'
import { api } from './api'

const redirectToLogin = () => window.location.replace(`${config.START_WEB_URL}`)

const fetchDeal = (action$) => {
  return action$.pipe(
    ofType(actions.fetchDeal.toString()),
    pluck('payload'),
    mergeMap((dealCode) => {
      return api.fetchBillingDeal(dealCode).pipe(
        map((deal) => {
          if (deal.status === DealStatus.ACTIVATED) {
            redirectToLogin()
          }

          return actions.fetchDealSuccess(deal)
        }),
        startWith(actions.fetchDealPending()),
        catchError(() => of(actions.fetchDealFailed()))
      )
    })
  )
}

const activateDeal = (action$) => {
  return action$.pipe(
    ofType(actions.activateDeal.toString()),
    pluck('payload'),
    mergeMap((dealDetails) => {
      const { dealId, accessToken } = dealDetails
      return api.activateDealV2({ dealId, accessToken }).pipe(
        map((response) => actions.activateDealSuccess(response)),
        startWith(actions.activateDealPending()),
        catchError((err) => of(actions.activateDealFailed(err)))
      )
    })
  )
}

const netSuiteDealActivationRedirect = (action$, state$) => {
  return action$.pipe(
    ofType(actions.activateDealSuccess.toString()),
    pluck('payload'),
    filter(() => [Flow.DEAL].includes(UserSelectors.getFlow(state$.value))),
    map(() => {
      track('Onboarding Account Setup Completed', {
        context: 'widget-onboarding',
        mobile: isMobile.any,
      })

      if (isMobile.any) {
        return push('/setup/touchless/mobile')
      } else {
        return push('/setup/touchless/welcome')
      }
    })
  )
}

export const epic = combineEpics(
  fetchDeal,
  activateDeal,
  netSuiteDealActivationRedirect
)
